import { JoiningProgress } from "@vivagym-joining/joining-progress";
import { LoadingStep } from "@vivagym-joining/vg-loading-step"
import { Notification } from "@vivagym-joining/notification";
import { ShoppingCart } from "@vivagym-joining/shopping-cart";
import { VgLogs } from "@vivagym-joining/vg-logs";
import { VgJoiningGtm } from "@vivagym-joining/vg-joining-gtm";

document.addEventListener("DOMContentLoaded", async () => {
	const locale = VgHelpers.getActualDomain();
	const loadingStep = new LoadingStep();

	window.notificationsActive = true;
	window.loadMode = false;

	console.log("joining-controller.js loaded!");

	let vgApiClient = new VgApiClient(VgHelpers.getCountry(), VgHelpers.getLanguage());
	let vgLogs = new VgLogs();

	const url = location.href;
	const urlArray = url.split("/");
	const urlStep = urlArray[urlArray.length - 2];
	const stepIndex = urlStep.split("-")[1];
	let progress = new JoiningProgress();

	const urlParams = new URLSearchParams(window.location.search);
	if (urlParams.has('tablet')) {
		await vgApiClient.setTablet().then((data) => {
			joiningController();
		});
	} else {
		joiningController();
	}

	function joiningController() {
		initNotifications();
		initModals();

		if (stepIndex != null && stepIndex != undefined) {
			// We're on a joining step
			manageFooterLanguageSelector();
		}

		if (stepIndex == progress.constInitStep) {
			console.log("step 0 Controller");
			step0Controller();
		}
		if (stepIndex == progress.constSelectGymStep) {
			console.log("step 1 Controller");
			step1Controller();
		}
		if (stepIndex == progress.constSelectQuote) {
			console.log("step 2 Controller");
			step2Controller();
		}
		if (stepIndex == progress.constUserData) {
			console.log("step 3 Controller");
			step3Controller();
		}
		if (stepIndex == progress.constSummary) {
			console.log("step 4 Controller");
			step4Controller();
		}
	}
	async function step0Controller() {
		progress = new JoiningProgress();
		await progress.load();
		if (await redirectIfWeHaveProgressOnStep0(progress)) {
			return;
		}

		JoiningProgress.initStep(progress);
		//enableCompletedStepEditButton(stepIndex, progress);

		document.addEventListener("initJoining", async (event) => {
			await progress.load();
			const user = event.detail.user;
			//console.log('user', user);

			let step0 = { step: stepIndex, completed: false, name: 'step-joining-init', data: {name : user.data.name, email : user.data.email, country : user.country, newsletter : user.data.newsletter} };
			progress.createStep(step0);
			// TODO: if user comes here from not finished process, load progress and redirect to last step

			let token;
			let userToken;
			let externalId;

			//TODO: Move this logic to PHP - https://vivagymgroup.atlassian.net/browse/WEB-716
			switch (user.type) {
				// 1-Generate user token based on type;
				case "Lead":
				case "New":
				case "Guest":
					// TODO: Consider use the data event instead of progress and manage the token in the controller.
					if (user.type === 'Lead' && progress.getUserToken()) {
						userToken = progress.getUserToken();
					} else {
						token = await vgApiClient.getUserAnonymousToken(user.country, VgHelpers.getLanguage());
						userToken = token.token;
					}

					// 1.2-Generate externalId based on user token
					externalId = await vgApiClient.getUserExternalId(userToken, user.country);
					externalId = externalId['shopper-reference'];
					console.log('externalId', externalId);

					// 2-Update storage
					progress.setUserExternalId(externalId);
					progress.setUserType(user.type);
					progress.setUserCountry(user.country);
					progress.setUserPersonData(user.personData);
					progress.setUserToken(userToken);
					progress.setUserTokenCreation(new Date().toLocaleString());
					progress.setStepCompleted(progress.constInitStep);
					await progress.save();
					// Track new user registration
					VgJoiningGtm.pushUserIdToDataLayer("Registro_usuario_nuevo", externalId);

					// 3-Go to step 1
					redirectToSelectGym();
					break;
				case "Active":
					VgJoiningGtm.pushUserIdToDataLayer("Login_socio", progress.getUserExternalId());
					window.location.href = JoiningVars.get_modal_setting_field('active', 'modal_redirect_url', VgHelpers.getActualDomain());
					break;
				case "Inactive":
				case "Suspended":
					// 1-Generate user token by externalId: get_user_token;
					externalId = user.personData.personTypeAndStatus.personId.externalId;
					progress.setUserExternalId(externalId);
					await progress.save();

					token = await vgApiClient.getUserToken();
					userToken = token.token;
					//console.log('userToken', userToken);
					progress.setUserToken(userToken);
					progress.setUserTokenCreation(new Date().toLocaleString());

					progress.setUserType(user.type);
					progress.setUserCountry(user.country);
					progress.setUserPersonData(user.personData);

					let gymData = await vgApiClient.getGymById(user.personData.person.personId.center);
					let stepSelectGymData = {id : user.personData.person.personId.center, name: gymData.name, country : gymData.address.country, city: gymData.address.zipName, openingDate:gymData.openingDate  };
					let stepSelectGym = { step: progress.constSelectGymStep, completed: true, name: 'step-joining-select-gym', data: stepSelectGymData };
					progress.createStep( stepSelectGym );

					let userHasSubscription = user.personData.subscriptions.length > 0 ? true : false;
					let stepSelectQuote = getStep2DataFromSubscription(user, progress, userHasSubscription);

					progress.createStep( stepSelectQuote );

					progress.setStepCompleted(progress.constSelectQuote);
					await progress.save();
					//console.log('progress',progress);
					VgJoiningGtm.pushUserIdToDataLayer("Login_ex-socio", externalId);

					// TODO: Force user to go step select quote
					userHasSubscription = false;
					// 3-Go to step 3
					if (userHasSubscription) {
						console.log('Subscription found, redirect to step 3');
						window.location.href = VgHelpers.getSelectedSlugForJoining('wizard_slug_joining_user_data');
					} else {
						console.log('No subscription found, redirect to step 2');
						window.location.href = VgHelpers.getSelectedSlugForJoining('wizard_slug_joining_select_quote');
					}

					break;
				case "Blacklist":
					window.location.href = JoiningVars.get_modal_setting_field('blacklist', 'modal_redirect_url', VgHelpers.getActualDomain());
					break;
				default:
					console.error("User type not found");
					break;
			}
		});

		// We need to check if we have sso login after the listener is added
		await checkIfSSOLogin();
		loadingStep.remove();
	}

	async function step1Controller() {
		await progress.load();
		JoiningProgress.initStep(progress);
		if (checkUserProgressBeforeContinue(progress)) {
			return;
		}
		await enableCompletedStepEditButton(stepIndex, progress);

		loadingStep.remove();

		document.addEventListener("selectedGym", async (event) => {
			const selectedGym = event.detail;
			console.log("Loaded progress data:", progress);

			let can_we_continue = await manageSpecialFlowsWithOtherCountries(progress, selectedGym.country.toLowerCase());
			if (!can_we_continue){
				return;
			}

			// Check if the selected gym matches the gym in step 1
			let sameGym = progress.stepData.some(
				(step) => step.step === progress.constSelectGymStep && step.data.id === selectedGym.id
			);

			let isGymOpen = true;
			if (progress.getUserType() === "Active") {
				isGymOpen = progress.checkIfGymIsOpen(selectedGym.openingDate);
				if (isGymOpen) {
					new VgModal({
						title: JoiningVars.get_form_field("modals").joining_user_active_bad_gym.title,
						description: JoiningVars.get_form_field("modals").joining_user_active_bad_gym.content,
						data: [],
						type: "error",
						template: "basic",
					});
					return;
				}
			}

			if (!sameGym) {
				// If the gym is different or step 1 does not exist, reset step 2
				progress.updateStepData(progress.constSelectQuote, {})
				console.log("Gym changed or not found in step 1, reset step 2:", progress);
			}

			// Update step 1 with the selected gym
			let stepStatus = { step: stepIndex, name : 'step-joining-select-gym', data: selectedGym, completed: true};
			progress.createStep(stepStatus);
			progress.setCurrentStep(stepIndex);

			// Track gym selection event
			VgJoiningGtm.pushToDataLayer("your_center", {
				item_country: progress.getGymCountry(),
				item_city: progress.getGymCity(),
				item_category: selectedGym.name,
				index: progress.basket ? progress.basket.products.length : 0,
				quantity: 1,
			});

			switch (progress.user.type) {
				case "Lead":
				case "New":
					// Only generate lead if New user
					if (progress.user.type === 'New') {

						let lead = await vgApiClient.createUserLead(progress.getStepInitName(), progress.getStepInitEmail(), selectedGym.id,  selectedGym.country);
						console.log('Created Lead:', lead);

						let externalId = await vgApiClient.getUserExternalId(lead.token, progress.getUserCountry());
						externalId = externalId['shopper-reference'];

						progress.setUserType("Lead");
						progress.setUserToken(lead.token);
						progress.setUserExternalId(externalId);
						await progress.save();
					}

					await updateExtendedAttributes(progress);

					// TODO: If we don't send email on updateUserCommunications it will be deleted, it's a bug from middleware. Waiting for fix.
					const wishToRecieveNewsletter = progress.getStepInitRecieveNewsletter();
					const userCommunications = wishToRecieveNewsletter ? { email: progress.getStepInitEmail(), newsletter : progress.getStepInitRecieveNewsletter() } : { email: progress.getStepInitEmail() };
					const updatedUserCommunications = await vgApiClient.updateUserCommunications(userCommunications, progress.getUserCountry());
					console.log('updateUserCommunications', updatedUserCommunications);

					await updateExtendedAttributes(progress);

					break;
				case "Guest":
					break;
				case "Active":
					if (isGymOpen) {
						window.location.href = JoiningVars.get_modal_setting_field('active', 'modal_redirect_url', VgHelpers.getActualDomain());
					}
					break;
				case "Inactive":
				case "Suspended":
					await updateExtendedAttributes(progress);
					break;
				case "Blacklist":
					// Block user
					break;
				default:
					console.error("User type not found");
					break;
			}

			if (!progress.stepData[progress.constSelectQuote]) {
				let step2 = { step: progress.constSelectQuote, completed: false, name: 'step-joining-select-quote', data: {} };
				progress.createStep(step2);
			}

			// Save the updated progress
			await progress.save();
			console.log("Progress after adding step 1:", progress);

			redirectToSelectQuote();
		});
	}

	async function step2Controller() {
		await progress.load();

		const urlParams = new URLSearchParams(window.location.search);

		if (urlParams.has('gym')) {
			const gymId = urlParams.get('gym');
			let gymData = await vgApiClient.getGymById(gymId);

			if (!gymData || gymData?.extendedAttributes?.find(attr => attr.id === 'VisibleInNewJP')?.value === 'false') {
				progress = new JoiningProgress();
				await progress.save();
				redirectToInitForm();
			}

			if (gymData.name && gymData?.extendedAttributes?.find(attr => attr.id === 'VisibleInNewJP')?.value === 'true') {

				// TODO: move user creation to a separate function
				progress = new JoiningProgress();
				await progress.save();
				const country = gymData.address.country.toLowerCase();
				const token = await vgApiClient.getUserAnonymousToken(country, VgHelpers.getLanguage());
				const userToken = token.token;
				const externalId = await vgApiClient.getUserExternalId(userToken, country);

				progress.setUserType('Guest');
				progress.setUserCountry(country);
				progress.setUserExternalId(externalId['shopper-reference']);
				progress.setUserToken(userToken);
				progress.setUserTokenCreation(new Date().toLocaleString());


				progress.addStep({ step: progress.constInitStep, name: 'step-joining-init', completed: true, data: { name: null, email: null, newsletter: null, country: country } });
				progress.addStep({ step: progress.constSelectGymStep, name: 'step-joining-select-gym', completed: true, data: { id: gymId, name: gymData.name, country: country, city: gymData.address.zipName, openingDate:gymData.startupDate } });
				progress.addStep({ step: progress.constSelectQuote, name: 'step-joining-select-quote',completed: false, data: {} });

				await progress.save();

				console.log('Saved progress with gym', progress);
			}
		}

		if (!urlParams.has('gym') && checkUserProgressBeforeContinue(progress)) {
			return;
		}

		enableCompletedStepEditButton(stepIndex, progress);

		JoiningProgress.initStep(progress);
		renderBasketPreview();

		loadingStep.remove();

		removeBasketLoading();

		let shoppingCart = new ShoppingCart();
		let shoppingBasket;

		document.addEventListener("formSubscriptionUpdated", async (event) => {
			if (window.loadMode) {
				return;
			}

			let submitButton = document.querySelector('.vg-select-quote__submit');

			addBasketLoading();
			submitButton.disabled = true;

			let gymId = progress.getGymId();

			const selection = event.detail;

			progress.updateStepData(stepIndex, selection);
			progress.setCurrentStep(stepIndex);

			// Shopping Basket Generation

			shoppingCart.setGym(gymId);

			if (selection['vg-select-quote'][0].type === 'EFT') {
				shoppingCart.setEftSubscription(selection['vg-select-quote'][0].value);
			}

			if (selection['vg-select-quote'][0].type === 'CASH') {
				shoppingCart.setCashSubscription(selection['vg-select-quote'][0].value);
			}

			if (selection['vg-select-quote--addons']) {
				selection['vg-select-quote--addons'].forEach(addon => {
					shoppingCart.addAddOn(addon.value);
				});
			}

			if (selection['vg-select-quote--clipcard']) {
				selection['vg-select-quote--clipcard'].forEach(clipcard => {
					shoppingCart.addClipCard(clipcard.value);
				});
			}

			if (urlParams.has('promo')) {
				const promoCode = urlParams.get('promo');
				const country = progress.getGymCountry();
				if (promoCode) {
					const promoCodeOk = await vgApiClient.validatePromoCode(gymId, promoCode, country, true);
					if (promoCodeOk.error == null && promoCodeOk.valid == true) {
						shoppingCart.setPromotionCode(promoCode)
						console.log('saved promo code: ' + promoCode);
					} else {
						new VgModal({
							title: 'Error',
							description: 'El código promocional no es válido.',
							data: [],
							type: 'error',
							template: 'basic',
						});
					}
				}
			}

			shoppingCart.setCountry(progress.getGymCountry()?.toLowerCase());
			shoppingBasket = await shoppingCart.process();

			if ( shoppingBasket && null === shoppingBasket.error ) {
				progress.setBasket(shoppingBasket.shoppingBasket);
				progress.setBasketResume(shoppingBasket.resume);
			} else {
				if ( shoppingBasket ) {
					console.error("Error processing shopping cart:", shoppingBasket.error);
					console.log('Check Repeat Product', checkErrorBasket(shoppingBasket.error, 'ProductPurchaseAllowedQuantityExceededException'));
					if ( checkErrorBasket(shoppingBasket.error, 'ProductPurchaseAllowedQuantityExceededException') ) {
						resetClipcardSelection();
						shoppingCart.showErrorModalClipcard();
					}
				} else {
					console.log('Retry shopping cart process');
					shoppingBasket = await shoppingCart.process();
					if (!shoppingBasket || checkErrorBasket(shoppingBasket.error, 'addEFTSubscription') ) {
						resetClipcardSelection();
						shoppingCart.showErrorModalBasket();
					}
				}
			}

			progress.setBasketParams(shoppingCart.collectParams());

			await progress.save();
			console.log('progress with basket',progress);

			// Track in GTM add to cart event
			if (shoppingBasket && null === shoppingBasket.error) {
				const shoppingBasketItems =
					shoppingBasket.shoppingBasket.products.reduce(
						(acc, product) => {
							// @&& !product.productName.includes("Creation Pase de un dia")
							//  @todo: ask Ale and WindUp or MKTG about pase de un día, is sending 2 products but is 1
							if (!product.productName.includes("Pro rata")) {
								const item = {
									item_name: product.productName,
									item_id: product.productKey.id,
									price: product.price.price,
									monthly_price: product.price.normalPrice,
									item_country: progress.getGymCountry(),
									item_city: progress.getGymCity(),
									item_category: progress.stepData[1] ? progress.stepData[1].data.name : '',
									item_variant: product.price.addons
										? product.price.addons.join(" / ")
										: "",
									index: acc.length + 1,
									quantity: 1,
								};
								acc.push(item);
							}
							return acc;
						},
						[]
					);
				VgJoiningGtm.pushToDataLayer("add_to_cart", {
					ecommerce: {
						items: shoppingBasketItems,
					},
				});
			}

			renderBasketPreview();

			// Update user extended attributes
			if (progress.getUserType() === "Inactive" || progress.getUserType() === "Suspended" || progress.getUserType() === "Lead") {
				await updateExtendedAttributes(progress);
			}

			submitButton.disabled = false;

		});

		document.addEventListener("formSubscriptionSubmit", async (event) => {
			const selection = event.detail;
			await progress.load();

			if ( shoppingBasket && null === shoppingBasket.error ) {
				progress.basket = shoppingBasket.shoppingBasket;
			}

			progress.updateStepData(stepIndex, selection);
			progress.setStepCompleted(stepIndex);
			progress.setCurrentStep(stepIndex);
			await progress.save();

			redirectToUserData();
		});

	}

	async function step3Controller() {
		await progress.load();
		if (checkUserProgressBeforeContinue(progress)) {
			return;
		}
		let currentStepData = progress.getUserDataStep();

		if (!currentStepData) {
			console.log('No user data found, creationg step 3');
			let step3 = { step: stepIndex, name: 'step-joining-user-data',completed: false, data: {} };
			progress.createStep(step3);
			progress.setCurrentStep(stepIndex);
			await progress.save();
		}

		JoiningProgress.initStep(progress);
		enableCompletedStepEditButton(stepIndex, progress);

		loadingStep.remove();

		document.addEventListener("formDataSubmit", async (event) => {
			const formData = event.detail;

			loadingStep.init();
			await progress.load();

			//nie come without "-"
			if (formData["id-card-type"] === 'nie') {
				let number = formData["id-number"];
				formData["id-number"] = number.toUpperCase().replace(/^([XYZ])(\d{7})([A-Z])$/, '$1-$2-$3');
			}

			// TODO: Examine why we need to create step3 data again
			currentStepData = progress.getUserDataStep();
			if (!currentStepData) {
				console.log('No user data found, creationg step 3');
				let stepStatus = { step: stepIndex, name: 'step-joining-user-data',completed: false, data: {} };
				progress.createStep(stepStatus);
			}

			progress.updateStepData(stepIndex, formData);

			let userType = progress.getUserType();
			let country = progress.getUserCountry();
			let gymId = progress.getGymId();

			let updatedUser;
			let updatedUserCommunications;
			let updatedSurveys;

			let newUser = false;

			//TODO: Move this logic to PHP - https://vivagymgroup.atlassian.net/browse/WEB-717
			switch (userType) {
				case "Lead":
					if (country.toLowerCase() !== progress.getGymCountry().toLowerCase()) {
						updatedUser = await vgApiClient.cleanUserLead(country);
						console.log('cleanLead', updatedUser);
						newUser =  await createUserFromFormData(gymId, formData, progress.getGymCountry());
						if (newUser) {
							country = progress.getGymCountry().toLowerCase();
							progress.setUserCountry(country);
						} else {
							loadingStep.remove();
							return;
						}
					}

					if (!newUser){
						updatedUser = await vgApiClient.updateUser(formData, country);
						console.log('updatedUser', updatedUser);
						progress.setUserPersonDataPerson(updatedUser.person);
						progress.setUserExternalId(updatedUser.person.personId.externalId);
						VgJoiningGtm.pushUserIdToDataLayer("User_data_updated",  progress.getUserExternalId());
					}

					updatedUserCommunications = await vgApiClient.updateUserCommunications(formData, country);
					console.log('updateUserCommunications', updatedUserCommunications);

					updatedSurveys = await updateSelectedSurveyOptions(progress, formData);

					break;
				case "Guest":
					newUser =  await createUserFromFormData(gymId, formData, progress.getGymCountry());
					if (newUser) {
						country = progress.getGymCountry().toLowerCase();
						progress.setUserCountry(country);
					} else {
						loadingStep.remove();
						return;
					}

					updatedSurveys = await updateSelectedSurveyOptions(progress, formData);
					updatedUserCommunications = await vgApiClient.updateUserCommunications(formData, country);

					await updateExtendedAttributes(progress);

					updatedSurveys = await updateSelectedSurveyOptions(progress, formData);

					VgJoiningGtm.pushUserIdToDataLayer("Registro_usuario_nuevo", progress.getUserExternalId());
					break;
				case "Active":
					// Managed on initVgLoginListener step-user-data
					break;
				case "Inactive":
				case "Suspended":
					progress.setUserType(userType);
					let token = await vgApiClient.getUserToken();
					let userToken = token.token;
					progress.setUserToken(userToken);

					updatedUser = await vgApiClient.updateUser(formData, country);
					console.log('updateUser', updatedUser);

					updateSelectedSurveyOptions = await updateSelectedSurveyOptions(progress, formData);

					updatedUserCommunications = await vgApiClient.updateUserCommunications(formData, country);
					VgJoiningGtm.pushUserIdToDataLayer("User_data_updated",  progress.getUserExternalId());
					break;
				case "Blacklist":
					// Block user
					break;
				default:
					console.error("User type not found");
					break;
			}

			await progress.save();
			console.log("Final Progress after adding step 4:", progress);

			redirectToSummary();
		});

		document.addEventListener("resetLead", async (event) => {
			const country = progress.getUserCountry();

			//When we need to reset a Lead, we need to Reset Previous Lead, not actual user
			const final_external_user = progress.getUserExternalId();
			console.log('Resetting lead');
			const old_external_id = event.detail.old_external_id;
			progress.setUserExternalId(old_external_id);
			await progress.save();

			const updatedUser = await vgApiClient.cleanUserLead(country);
			console.log('cleanLead', updatedUser);

			progress.setUserExternalId(final_external_user);
			// We need to update saved user's email on personData
			const email = document.querySelector("input[name='email']").value;
			progress.updateUserPersonDataEmail(email);
			await progress.save();
		});

		function isFormFilled(form) {
			for (let element of form.elements) {
				if (element.type !== "submit" && element.value.trim() !== "") {
					return true;
				}
			}
			return false;
		}

		window.addEventListener("beforeunload", async (event) => {
			await progress.load();
			currentStepData = progress.getUserDataStep();
			
			if (!currentStepData) {
				const form = document.querySelector("#form-user-data");

				if (isFormFilled(form)) {
					console.log("The form has filled data.");
					// Display a confirmation dialog
					event.preventDefault(); // Standard way to prevent the default action
					event.returnValue = ""; // Required for Chrome to display the dialog
				} else {
					console.log("The form is empty.");
				}
			}
		});
	}

	async function createUserFromFormData(gymId, formData, country){
		const newUser =  await vgApiClient.createUser(gymId, formData, country);
		if (newUser.error !== null) {
			console.error('Error creating user:', newUser.error);

			if (newUser.error.includes("DUPLICATE_PERSON")) {
				document.querySelector("input[name='email']").value = '';
				document.querySelector("input[name='email-confirm']").value = '';
				document.querySelector("input[name='id-number']").value = '';

				const vgForms = new VGForms();
				const errorMessage = JoiningVars.get_form_field('user-data').error_duplicated;

				vgForms.showErrorElement(document.querySelector("input[name='email']"), errorMessage);
				vgForms.showErrorElement(document.querySelector("input[name='id-number']"), errorMessage);

				const submitButton = document.querySelector('input[name="user-data-form-submit"]');
				submitButton.disabled = false;
				loadingStep.remove();

				return false;
			} else if (newUser.error.includes("Empty email or invalid")) {
				const vgForms = new VGForms();
				const errorMessage = JoiningVars.get_form_field('user-data').email_invalid;

				document.querySelector("input[name='email']").value = '';

				vgForms.showErrorElement(document.querySelector("input[name='email']"), errorMessage);

				const submitButton = document.querySelector('input[name="user-data-form-submit"]');
				submitButton.disabled = false;
				loadingStep.remove();
				return false;
			} else {
				console.error("Error in AJAX request:", newUser.error);
				window.location.reload();
			}
		}

		progress.setUserPersonDataPerson(newUser.person);
		progress.setUserExternalId(newUser.person.personId.externalId);
		progress.setUserToken(newUser.token);
		progress.setUserType("Lead");

		// Update step0 data
		let newDataStep0 = { name : newUser.person.firstName, email : formData.email, newsletter : formData.newsletter ? true : false, country : country };
		progress.setInitStepData( newDataStep0 );

		await progress.save();
		return newUser;
	}

	async function step4Controller() {
		await progress.load();

		if (checkUserProgressBeforeContinue(progress)) {
			return;
		}
		if (!progress.getSummaryStep()) {
			console.log('No summary data found, creationg step 4');
			const step4 = { step: stepIndex, name: 'step-joining-summary', completed: false, data: {} };
			progress.createStep(step4);
			progress.setCurrentStep(stepIndex);
			await progress.save();
		}
		await JoiningProgress.initStep(progress);

		if (await vgApiClient.checkIfIsAnonymous(null)) {
			await vgLogs.storeOnLogProblemWithAnonymousStep4(progress);
			progress = new JoiningProgress();
			await progress.save();
			redirectToInitForm();
			return;
		}

		VgJoiningGtm.pushToDataLayer(
			"begin_checkout",
			{ecommerce: {
				items: [{
					item_name: progress.getSelectQuoteStep()?.data["vg-select-quote"][0].webname,
					item_id: progress.basketParams.eftSubscription,
					price: progress.basket.totalAmount,
					monthly_price: progress.basketResume.monthlyPrice.price,
					item_country: progress.getGymCountry(),
					item_city: progress.getGymCity(),
					item_category:  progress.stepData[1] ? progress.stepData[1].data.name : '',
					item_variant: progress.getBasketResume()?.payNowPrice.extras.join(' / '),
					index: 1,
					quantity: 1,
				}]
			}}
		);

		if (await checkIfBasketHaveSameExternalId(progress)) {
			await vgLogs.storeOnLogProblemWithBasketId(progress);
			progress = new JoiningProgress();
			await progress.save();
			redirectToInitForm();
			return;
		}

		if (await basketIsExternalId(progress)){
			await vgLogs.storeOnLogProblemWithBasketAnonymousToken(progress);
			progress = new JoiningProgress();
			await progress.save();
			redirectToInitForm();
			return;
		}

		loadingStep.remove();

		document.addEventListener("VgPaymentRegisterIban", async (event) => {
			console.log('VgPaymentRegisterIban', event.detail);
			const data = event.detail;

			let sepaData = {
				accountHolder: data['account-holder-name'],
				iban: data['account-holder-iban'],
			};

			await progress.load();
			progress.setStepResumeIban(data['account-holder-iban']);
			progress.setStepResumeIbanHolder(data['account-holder-name']);
			await progress.save();

			const country = progress.getUserCountry();

			await vgLogs.storeOnLogSetPaymentAgreementSepa(data, progress);
			const updatedUserSepa = await vgApiClient.setPaymentAgreementSepa(sepaData, country);
			console.log(updatedUserSepa);

			if (updatedUserSepa.error !== null) {
				console.error('Error updating user Sepa:', updatedUserSepa.error);
				document.dispatchEvent(new CustomEvent('initModal', { detail: 'error' }));
				document.addEventListener("modalClosed", async function (event) {
					await manageResponseError(updatedUserSepa.error);
				});
			}

			if (updatedUserSepa.error === null && data.requirePayNow === true) {
				await vgLogs.storeOnLogVgPaymentIbanRegistered(updatedUserSepa, progress);
				document.dispatchEvent(new CustomEvent('VgPaymentIbanRegistered', { detail: updatedUserSepa }));
			}

			if (updatedUserSepa.error === null && data.requirePayNow === false) {

				await progress.load();

				// Close shopping basket
				const shoppingBasketClosed = await closeShoppingBasket(progress);
				console.log('shoppingBasketClosed', shoppingBasketClosed);

				if (shoppingBasketClosed.error !== null) {
					console.error('Error closing shopping basket:', shoppingBasketClosed.error);
					document.dispatchEvent(new CustomEvent('initModal', { detail: 'error' }));
					document.addEventListener("modalClosed", async function (event) {
						await manageResponseError(shoppingBasketClosed.error);
					});
				}

				await vgLogs.storeOnLogVgFinishRegisterIbanProcessWithoutPayNow(progress, progress.basketParams, shoppingBasketClosed);

				// Compras completadas
				VgJoiningGtm.pushToDataLayer(
					"purchase",
					{ecommerce: {
						items: [{
							item_name: progress.getSelectQuoteStep()?.data["vg-select-quote"][0].webname,
							item_id: progress.basketParams.eftSubscription,
							price: progress.basket.totalAmount,
							monthly_price: progress.basketResume.monthlyPrice.price,
							item_country: progress.getGymCountry(),
							item_city: progress.getGymCity(),
							item_category:  progress.getGymName(),
							item_variant: (progress.basketResume.payNowPrice.extras ?? []).join(' / '),
							index: 1,
							quantity: 1,
						}]
					}}
				);

				await redirectToThankYouPageAndClearProgress();
			}
		});
		document.addEventListener('VgPaymentCompleted', async (event) => {
			console.log('VgPaymentCompleted', event.detail);
			const data = event.detail;
			if (data.status === 'success') {
				await progress.load();

				await vgLogs.storeOnLogVgFinishPayment(progress, data);

				if (true === data.freepayment) {
					// Close shopping basket
					const shoppingBasketClosed = await closeShoppingBasket(progress);
					console.log('shoppingBasketClosed', shoppingBasketClosed);
					VgJoiningGtm.pushToDataLayer("Free_payment_success", progress.getUserExternalId());
				} else {
					VgJoiningGtm.pushToDataLayer("Payment_success", progress.getUserExternalId());
				}

				await redirectToThankYouPageAndClearProgress();
			} else {
				console.error('Payment failed:', data);
				redirectToUserData();
			}
		});

	}

	async function redirectToThankYouPageAndClearProgress() {
		const thankYouPageUrl = JoiningVars.get_setting_field('vg_link_thank_you_page', locale);
		const thankYouPageUrlWithDomain = '/'+ VgHelpers.getActualDomain() + thankYouPageUrl;

		let data = [
			{name: 'client_name', value: progress.getStepInitName()},
			{name: 'client_email', value: progress.getStepInitEmail()},
		];

		progress = new JoiningProgress();
		await progress.save();

		redirectPageWithPostData(thankYouPageUrlWithDomain, data);
	}

	async function closeShoppingBasket(progress) {
		const basketParams = {
			shoppingBasketKey: progress.getBasket().shoppingBasketKey,
			amountPaidByCustomer: progress.getBasket().totalAmount,
			customPaymentMethodId: 1,
			externalPaymentTransactionReference: progress.getUserExternalId() + '-SB0',
		};
		const country = progress.getUserCountry();

		return await vgApiClient.payShoppingBasket(basketParams, country);
	}

	async function manageSpecialFlowsWithOtherCountries(progress, selectedGymCountry){
		// Check if guest user change country when he selects gym.
		if (progress.getUserType() === 'Guest' && (progress.getUserCountry().toLowerCase() !== selectedGymCountry.toLowerCase())) {
			console.log("We change the country of the Guest");
			// We take a new anonymous token for the new country.
			let token = await vgApiClient.getUserAnonymousToken(selectedGymCountry, VgHelpers.getLanguage());
			let userToken = token.token;

			await switchAnonymousUser(userToken, selectedGymCountry);
		}

		// Manage if not guest user change country Gym
		if (progress.getUserType() === 'Lead' || progress.getUserType() === 'Inactive' || progress.getUserType() === 'Suspended') {
			if (progress.getUserCountry().toLowerCase() !== selectedGymCountry.toLowerCase()) {
				if (progress.getUserType() === 'Inactive' || progress.getUserType() === 'Suspended') {
					VgHelpers.showModalCountryChange(selectedGymCountry);
					return false;
				} else {
					console.log("Lead from another country");
					let checkResult = await vgApiClient.checkIfExist(progress.getStepInitEmail(), selectedGymCountry);
					console.log("checkIfExist Result:",checkResult);
					//We need to be sure that user country !== gym country
					if (checkResult.country.toLowerCase() !== selectedGymCountry.toLowerCase()) {
						let userToken = checkResult.token;
						let do_we_have_token = !!(userToken);
						if (do_we_have_token) {
							// If we have token we can delete it to create him with correct Country
							const updatedUser = await vgApiClient.cleanUserLead(progress.getUserCountry());
							console.log('cleanLead', updatedUser);

							await switchAnonymousUser(userToken, selectedGymCountry);
						} else {
							VgHelpers.showModalCountryChange(selectedGymCountry);
							return false;
						}
					}
				}
			}
		}

		return true;
	}

	async function switchAnonymousUser(userToken, new_country){
		let externalIdByToken = await vgApiClient.getUserExternalId(userToken, new_country);
		let externalId = externalIdByToken['shopper-reference'];

		progress.setUserType("New");
		progress.setStepDataCountry(new_country);
		progress.setUserCountry(new_country);
		progress.setUserExternalId(externalId);
		progress.setUserToken(userToken);
		progress.setUserTokenCreation(new Date().toLocaleString());
		await progress.save();
	}

	async function redirectIfWeHaveProgressOnStep0(progress){
		if ( VgHelpers.getCountry() === progress.getStepDataCountry() ) {
			if (progress.getRegisteredSteps().length > 0) {
				const initStep = progress.getInitStep();
				if (initStep) {
					if(initStep.step === progress.constInitStep) {
						if (progress.getSelectGymStep()) {
							if (progress.getSelectQuoteStep()) {
								progress.setCurrentStep(progress.constUserData);
								await progress.save();
								redirectToUserData();
								return true;
							} else {
								progress.setCurrentStep(progress.constSelectQuote);
								await progress.save();
								redirectToSelectQuote();
								return true;
							}
						} else {
							progress.setCurrentStep(progress.constSelectGymStep);
							await progress.save();
							redirectToSelectGym();
							return true;
						}
					}
				}
			}
		} else {
			progress = new JoiningProgress();
			await progress.save();
			console.log('Progress cleared', progress);
		}
		return false;
	}

	async function manageResponseError(error) {
		if (error === '403') {
			await vgLogs.storeOnLogVGAnonymousForbiddenMethod(progress);
			progress = new JoiningProgress();
			await progress.save();
			redirectToInitForm();
		} else {
			window.location.reload();
		}
	}

	function checkUserProgressBeforeContinue(progress) {
		if (progress.getRegisteredSteps().length === 0){
			redirectToInitForm();
			return true;
		}
		return false;
	}

	async function checkIfBasketHaveSameExternalId(progress) {
		await vgApiClient.getBasketExternalId(progress.getBasketKey()).then((data) => {
			if (data.error === null) {
				const externalId = progress.getUserExternalId();
				const shoppingExternalId = data.externalId;
				if (shoppingExternalId !== externalId) {
					return true;
				}
			}
		});

		return false;
	}

	async function basketIsExternalId(progress) {
		let data = await vgApiClient.getBasketExternalId(progress.getBasketKey());
		const shoppingExternalId = data.externalId;
		const isShoppingAnonymous = await vgApiClient.checkIfIsAnonymous(shoppingExternalId);

		if (isShoppingAnonymous) {
			return true;
		}

		return false;
	}

	async function enableCompletedStepEditButton(stepIndex, progress) {
		const registeredSteps = progress.getRegisteredSteps();

		registeredSteps?.forEach((step) => {
			if (step.stepIndex === 0 || step.stepIndex <= stepIndex || step.stepIndex === undefined) {
				return;
			}
			appendEditButton(step.stepIndex);
		});
	}

	function appendEditButton(stepIndex) {
		const step = document.querySelector(`[data-index="${stepIndex}"]`);
		const stepParent = step?.parentElement;
		const stepHeader = stepParent?.parentElement;

		const editButtonText = JoiningVars.get_setting_field('vg_str_edit_step', locale);

		if ( stepParent && stepHeader ) {
			const editContainer = document.createElement('a');
			editContainer.classList.add('vg-joining-process__step-head-link');
			editContainer.href = `/${locale}/joining-${stepIndex}/`;

			const editText = document.createElement('div');
			editText.classList.add('vg-joining-process__step-head-link-edit');
			editText.innerHTML =
			`
			<div class="vg-joining-process__step-head-icon-edit">
				<span>${editButtonText}</span>
			</div>
			`;
			stepParent?.appendChild(editText);
			editContainer.appendChild(stepParent);

			stepHeader.innerHTML = '';
			stepHeader.appendChild(editContainer);
		}

	}

	async function updateSelectedSurveyOptions(progress, formData) {
		let country = progress.user.country;
		let updatedUser = null;

		formData.questionnaries.forEach(async (questionnaire) => {
			const surveyData = {
				questionnaireId: questionnaire.questionnaireId,
				answers: questionnaire.answers
			};
			updatedUser = await vgApiClient.updateUserSurveys(surveyData, country);
		});

		console.log('updateUserSurveys', updatedUser);
		return updatedUser;
	}

	async function updateExtendedAttributes(progress) {
		const extendedAttributes = progress.getExtendedAttributes();
		console.log('extendedAttributes', extendedAttributes);
		const updatedUser = await vgApiClient.updateUserMultipleExtendedAttribute(extendedAttributes, progress.getUserCountry());
		console.log('Updated extendedAttributes', updatedUser);
		return updatedUser;
	}

	function redirectPageWithPostData(redirectUrl, data) {
		const form = document.createElement('form');
		form.name = 'redirectForm';
		form.method = 'POST';
		form.action = redirectUrl;
		form.style.display = 'none';

		data?.forEach(field => {
			const input = document.createElement('input');
			input.type = 'hidden';
			input.name = field.name;
			input.value = field.value;
			form.appendChild(input);
		});

		document.body.appendChild(form);

		form.submit();
	}

	async function checkIfSSOLogin() {
		const urlParams = new URLSearchParams(window.location.search);
		if (urlParams.has('ssoToken') && urlParams.has('externalId')) {
			const externalId = urlParams.get('externalId');
			const ssoToken = urlParams.get('ssoToken');
			const ssoUser = await vgApiClient.validateUserSSOToken(externalId, ssoToken, VgHelpers.getCountry());

			if (null === ssoUser.error) {
				let user = {
					// If we get user's type as Lead, we need to manage it as Inactive
					type: progress.filterUserType(ssoUser.personData?.personTypeAndStatus.personStatus) === 'Lead' ? 'Inactive' : progress.filterUserType(ssoUser.personData?.personTypeAndStatus.personStatus),
					country: ssoUser.personData?.person.address.country.toLowerCase(),
					data:
					{
						name: ssoUser.personData?.person.firstName,
						email: ssoUser.personData?.personCommunication?.email,
						newsletter : ssoUser.personData?.personCommunication?.wishToReceiveEmailNewsLetters
					},
					personData: ssoUser.personData,
				}
				document.dispatchEvent(new CustomEvent('initJoining', { detail: {user:user} }));
			} else {
				console.error('Error validating SSO token:', ssoUser.error);
			}
		}
	}

	function initModals() {
		document.addEventListener("initModal", function (event) {
			const modalType = event.detail;

			switch (modalType) {
				case "error":
					showErrorModal();
					break;
				default:
					console.error("Modal type not found");
					break;
			}
		});
	}

	function initNotifications() {
		if (!window.notificationsActive) {
			return;
		}

		document.addEventListener("selectedGym", (event) => {
			if (window.notificationsActive) {
				new Notification(
					JoiningVars.get_form_field("notifications").select + " " + event.detail.name,
					"success"
				);
			}
		});

		document.addEventListener("addSubscription", (event) => {
			if (window.notificationsActive) {
				new Notification(
					event.detail.selectedName + " " + JoiningVars.get_form_field("notifications").added,
					"success"
				);
			}
		});

		document.addEventListener("removeSubscription", (event) => {
			if (window.notificationsActive) {
				new Notification(
					event.detail.selectedName + " " + JoiningVars.get_form_field("notifications").deleted,
					"info"
				);
			}
		});

		document.addEventListener("removeAddon", (event) => {
			if (window.notificationsActive) {
				new Notification(
					JoiningVars.get_form_field("notifications").service + " " + event.detail.selectedName + " " + JoiningVars.get_form_field("notifications").deleted2,
					"info"
				);
			}
		});

		document.addEventListener("addAddon", (event) => {
			if (window.notificationsActive) {
				new Notification(
					JoiningVars.get_form_field("notifications").service + " " + event.detail.selectedName + " " + JoiningVars.get_form_field("notifications").added2,
					"success"
				);
			}
		});

		document.addEventListener("addClipcard", (event) => {
			if (window.notificationsActive) {
				new Notification(
					event.detail.selectedName + " " + JoiningVars.get_form_field("notifications").added2,
					"success"
				);
			}
		});

		document.addEventListener("removeClipcard", (event) => {
			if (window.notificationsActive) {
				new Notification(
					event.detail.selectedName + " " + JoiningVars.get_form_field("notifications").deleted2,
					"info"
				);
			}
		});
	}

	function manageFooterLanguageSelector() {

		let lang;
		const selectCountrySelected = document.querySelector(".site-footer__colophon-select-language .site-footer__select-language--item-selected a");
		const selectCountryItems = document.querySelector(".site-footer__colophon-select-language .site-footer__select-language--items");
		const selectCountryItem = document.querySelectorAll(".site-footer__colophon-select-language .site-footer__select-language--item");
		const selectListItemCountry = document.querySelector(".site-footer__select-language");

		if (!selectCountrySelected) {
			return;
		}

		selectCountrySelected.addEventListener("click", (event) => {
			event.preventDefault();
			lang = selectCountrySelected.getAttribute("data-lang");
		});

		selectCountryItem.forEach( option => {
			option.addEventListener("click", (event) => {
				if( selectListItemCountry.getAttribute("data-activate-modal") ) {
					event.preventDefault();
					const link = event.target.closest('a');
					lang = link.getAttribute("data-lang");

					if (lang === VgHelpers.getActualDomain()) {
						return;
					}

					const modalConfirmation = new VgModal({
						title: JoiningVars.get_form_field("modals").joining_change_country.title,
						description: JoiningVars.get_form_field("modals").joining_change_country.content,
						data: [],
						type: "warning",
						template: "countrySelector",
						status: "",
					});
				}
			});
		});

		document.addEventListener("modalClosed", () => {
			selectCountryItems.style.display = "none";
			selectCountrySelected.classList.remove("open");
		});

		document.addEventListener("modalLangSelectorBtn", async (event) =>{
			event.preventDefault();
			const progress = new JoiningProgress();
			await progress.save();
			window.location.href = '/' + lang + '/'+ JoiningVars.get_setting_field('wizard_slug_joining_init', lang);
		});

	}

	function redirectToInitForm() {
		window.location.href = VgHelpers.getSelectedSlugForJoining('wizard_slug_joining_init');
	}
	function redirectToSelectGym() {
		window.location.href = VgHelpers.getSelectedSlugForJoining('wizard_slug_joining_select_gym');
	}
	function redirectToSelectQuote() {
		window.location.href = VgHelpers.getSelectedSlugForJoining('wizard_slug_joining_select_quote');
	}
	function redirectToUserData() {
		window.location.href = VgHelpers.getSelectedSlugForJoining('wizard_slug_joining_user_data');
	}
	function redirectToSummary() {
		window.location.href = VgHelpers.getSelectedSlugForJoining('wizard_slug_joining_summary');
	}

	function getStep2DataFromSubscription(user, progress, userHasSubscription) {
		let stepSelectQuote = { step: progress.constSelectQuote, completed: true, name: 'step-joining-select-quote', data: {} };

		// TODO: Recovery Addons not full available now
		return stepSelectQuote;

		console.log ('Subscriptions: ', user.personData.subscriptions);
		let subscriptions = user.personData.subscriptions;
		let recoverSelectQuote = [];
		let recoverSelectQuoteAddons = [];

		if (!subscriptions) {
			return stepSelectQuote;
		}

		subscriptions.forEach(subscription => {
			if ( subscription.product ) {
				console.log('Subscription Product:', subscription.product);
				recoverSelectQuote.push({
					globalId: subscription.product.globalId,
					value: subscription.subscriptionId.id,
					webname: subscription.product.webname,
				});
			}

			// TODO: Addons not full available from endpoint
			if ( subscription.assignedAddOns ) {
				console.log('Subscription Addons:', subscription.assignedAddOns);
				let addons = subscription.assignedAddOns;
				addons.forEach(addon => {
					console.log('Addon:', addon);
					recoverSelectQuoteAddons.push({
						globalId: addon.globalId,  // We do not have access to the data from mw endpoint.
						name: addon.name,
						webname: addon.webname, // We do not have access to the data from mw endpoint.
					});
				});
			}
		});


		if (userHasSubscription) {
			stepSelectQuote = { step: progress.constSelectQuote, completed: true, name: 'step-joining-select-quote', data: {
					'vg-select-quote' : recoverSelectQuote,
					// 'vg-select-quote--addon' : user.personData.subscriptions,
				} };
		}

		return stepSelectQuote;
	}

	function checkErrorBasket ( error, message ) {
		if ( !error ) {
			return false;
		}
		if ( error.includes( message ) ) {
			return true;
		}
		return false;
	}

	function resetClipcardSelection() {
		const clipcardAcceptance = document.querySelectorAll(
			".vg-select-quote__clipcard-conditions input"
		);

		clipcardAcceptance?.forEach((acceptance) => {
			acceptance.checked = false;
			acceptance.disabled = false;
			acceptance.nextElementSibling.removeAttribute('disabled');
		});

		const clipcardCheckboxes = document.querySelectorAll(
			'input[name="vg-select-quote--clipcard"]'
		);

		clipcardCheckboxes?.forEach((clipcard) => {
			if (clipcard.checked) {
				clipcard.click();
			}
			clipcard.disabled = true;
			clipcard.nextElementSibling.setAttribute('disabled', true);
			clipcard.dispatchEvent(new Event('change'));
		});
	}

	function showErrorModal() {
		new VgModal({
			title: JoiningVars.get_form_field("modals").joining_error.title,
			description: JoiningVars.get_form_field("modals").joining_error.content,
			data: [],
			type: "error",
			template: "basic",
		});
	}

	function renderBasketPreview() {
		if (!progress.getBasketResume()) {
			return;
		}
		emptyBasketPreview();
		renderBasketPreviewPrice();
		renderBasketPreviewPrice('paynow');

		removeBasketLoading();
	}

	function emptyBasketPreview() {
		const basketElementMonthly = document.getElementById("vg-select-quote__cart-basket--monthly");
		const basketElementPayNow = document.getElementById("vg-select-quote__cart-basket--paynow");

		if (basketElementMonthly) {
			basketElementMonthly.innerHTML = '';
		}

		if (basketElementPayNow) {
			basketElementPayNow.innerHTML = '';
		}
	}

	function renderBasketPreviewPrice(type = 'monthly') {
		let dataResume;
		let dataBasket = progress.getBasket();

		let elementId = '';
		let headingLiteral = '';

		switch (type) {
			case 'monthly':
				dataResume = progress.getBasketResume().monthlyPrice;
				elementId = "vg-select-quote__cart-basket--monthly";
				headingLiteral = JoiningVars.get_form_field("pago-mensual");
				break;
			case 'paynow':
				dataResume = progress.getBasketResume().payNowPrice;
				elementId = "vg-select-quote__cart-basket--paynow";
				headingLiteral = JoiningVars.get_form_field("pago-unico");
				break;
			default:
				return null;
		}

		if (dataResume === 0) {
			renderBasketPreviewMobile(type, '', '');
			return;
		}

		let shoppingCart = new ShoppingCart();

		const basketElement = document.getElementById(elementId);

		if (basketElement) {

			const subtitleElement = document.createElement('div');
			subtitleElement.classList.add('vg-select-quote__cart-summary-subtitle', 'has-subtitle-s-font-size');
			subtitleElement.innerHTML = headingLiteral;

			basketElement.appendChild(subtitleElement);

			const tableBasketElement = document.createElement('table');
			tableBasketElement.classList.add('vg-select-quote__cart-summary-detail');

			const tableBodyBasketElement = document.createElement('tbody');
			let htmlTBody = '';
			let totalPrice = 0;

			let tableData = shoppingCart.getBasketCuoteDataTable(dataResume.fee, dataBasket, type, 'fee');
			let [htmlTable, totalTable] = renderItemTable(tableData);
			htmlTBody += htmlTable;
			totalPrice += totalTable;

			tableData = shoppingCart.getBasketCuoteDataTable(dataResume.extras, dataBasket, type, 'extras');
			[htmlTable, totalTable] = renderItemTable(tableData);
			htmlTBody += htmlTable;
			totalPrice += totalTable;

			if (type === 'paynow') {
				tableData = shoppingCart.getBasketCuoteDataTable(dataResume.others, dataBasket, type, 'others');
				[htmlTable, totalTable] = renderItemTable(tableData);
				htmlTBody += htmlTable;
				totalPrice += totalTable;
			}
			tableBodyBasketElement.innerHTML = htmlTBody;
			tableBasketElement.appendChild(tableBodyBasketElement);
			tableBasketElement.appendChild(renderTotalPrice(totalPrice));

			renderBasketPreviewMobile(type, headingLiteral, totalPrice);

			basketElement.appendChild(tableBasketElement);
		}
	}

	function renderItemTable(tableData) {
		let htmlResult = '';

		const tableRows = Object.keys(tableData['table-body']);
		tableRows.forEach(row => {
			const tableRowData = tableData['table-body'][row];
			htmlResult +=
			`<tr>
				<td class="vg-select-quote__table-label">
					<span>${tableRowData['table-row-label']}</span>
				</td>
				<td class="vg-select-quote__table-price">
					<span>${VgHelpers.formatNumberToPrice(tableRowData['table-row-price'])}</span>
				</td>
			</tr>`;
		});

		const totalPrice = tableData['table-footer-total-price'];
		return [htmlResult, totalPrice];
	}

	function renderTotalPrice (totalPrice) {
		const tableFooterBasketElement = document.createElement('tfoot');
		tableFooterBasketElement.innerHTML = `
			<tr class="vg-select-quote__table-total">
				<td class="vg-select-quote__table-label">
					<strong>TOTAL</strong>
				</td>
				<td class="vg-select-quote__table-price">
					<strong>${VgHelpers.formatNumberToPrice(totalPrice)}</strong>
				</td>
			</tr>
		`;
		return tableFooterBasketElement;
	}

	function renderBasketPreviewMobile(type, headingLiteral, totalPrice) {
		const mobileElement = document.getElementById('vg-select-quote__cart-basket--detail-mobile');
		if (!mobileElement) {
			return;
		}

		const priceContent = (totalPrice !== '') ? VgHelpers.formatNumberToPrice(totalPrice) : '';
		switch (type) {
			case 'monthly':
				mobileElement.querySelector('.vg-select-quote__subtitle--detail-mobile-monthly').textContent = headingLiteral;
				mobileElement.querySelector('.vg-select-quote__cart-basket--detail-mobile-monthly').textContent = priceContent;
				break;
			case 'paynow':
				mobileElement.querySelector('.vg-select-quote__subtitle--detail-mobile-paynow').textContent = headingLiteral;
				mobileElement.querySelector('.vg-select-quote__cart-basket--detail-mobile-paynow').textContent = priceContent;
				break;
			default:
				return null;
		}
		return true;
	}

	function addBasketLoading() {
		const basketResumenSummary = document.querySelector('.vg-select-quote__cart-summary-content');
		basketResumenSummary?.classList.add('is-loading');
	}

	function removeBasketLoading() {
		const basketResumenSummary = document.querySelector('.vg-select-quote__cart-summary-content');
		basketResumenSummary?.classList.remove('is-loading');
	}

});
